<!-- WRAP LAYOUT IF BOXED -->
<div class="container" *ngIf="_boxed; else basicLayoutBlock">
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</div>
<ng-template #basicLayoutBlock>
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</ng-template>
<!-- YOUR LAYOUT CONTENT GOES INSIDE HERE -->
<ng-template #contentTpl>
  <!-- PAGE SIDEBAR -->
  <pg-sidebar>
    <ng-template #sideBarOverlay>
      <!-- <div class="row">
        <div class="col-xs-6 no-padding">
          <a href="javascript:void(0)" class="p-l-40"><img src="assets/img/demo/social_app.svg" alt="socail">
          </a>
        </div>
        <div class="col-xs-6 no-padding">
          <a href="javascript:void(0)" class="p-l-10"><img src="assets/img/demo/email_app.svg" alt="socail">
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 m-t-20 no-padding">
          <a href="javascript:void(0)" class="p-l-40"><img src="assets/img/demo/calendar_app.svg" alt="socail">
          </a>
        </div>
        <div class="col-xs-6 m-t-20 no-padding">
          <a href="javascript:void(0)" class="p-l-10"><img src="assets/img/demo/add_more.svg" alt="socail">
          </a>
        </div>
      </div> -->
    </ng-template>
    <ng-template #sideBarHeader>
      <img [src]="'/assets/img/logo-american-window-film-horiz.png'" alt="logo" class="brand" width="175">
    </ng-template>
    <ng-template #menuItems>
      <pg-menu-items [Items]="menuLinks">
      </pg-menu-items>
    </ng-template>
  </pg-sidebar>
  <!-- PAGE CONTAINER -->
  <page-container class="{{environment.env}}">
    <pg-header [boxed]="_boxed">
      <!-- START MOBILE SIDEBAR TOGGLE -->
      <a href="javascript:void(0);" class="btn-icon-link toggle-sidebar" (click)="toggleMobileSidebar()">
        <i class="pg-icon">menu</i>
      </a>
      <!-- END MOBILE SIDEBAR TOGGLE -->
      <div class="d-flex align-items-center">
        <!-- START EMAIL MOBILE TOGGLE -->
        <!-- <a href="javascript:void(0);" class="toggle-secondary-sidebar align-items-center"
          (click)="toggleSecondarySideBar()" *ngIf="_layoutOption === 'email'">
          <span class="d-flex align-items-center">
            Inbox <span class="text-info">(12)</span> <span class="pg-icon">drop_down</span>
          </span>
        </a> -->
        <!-- END EMAIL MOBILE TOGGLE -->
        <div class="brand" [class.d-none]="_layoutOption === 'email'" [class.d-xl-block]="_layoutOption === 'email'"
          [class.d-lg-block]="_layoutOption === 'email'">
          <img [src]="'/assets/img/logo-american-window-film-horiz.png'" alt="logo" width="175">
        </div>
        <!--        <a href="#" class="btn btn-link text-primary m-l-20 d-none d-lg-inline-flex d-xl-inline-flex">Add New Item</a>-->
        <!--        <a href="javascript:void(0)" class="search-link d-none d-lg-block d-xl-block" (click)="openSearch($event)"><i-->
        <!--            class="pg-icon">search</i>Type anywhere to <span class="bold">search</span></a>-->
      </div>
      <div class="d-flex align-items-center">
        <!-- START NOTIFICATION LIST -->
        <!--        <ul class="d-lg-inline-block d-none notification-list no-margin  b-grey b-l b-r no-style p-l-20 p-r-20">-->
        <!--          <li class="p-r-10 inline">-->
        <!--            <div class="dropdown" dropdown>-->
        <!--              <a href="javascript:;" id="notification-center" class="header-icon btn-icon-link" dropdownToggle>-->
        <!--                <i class="pg-icon">world</i>-->
        <!--                <span class="bubble"></span>-->
        <!--              </a>-->
        <!--              &lt;!&ndash; START Notification Dropdown &ndash;&gt;-->
        <!--              <div *dropdownMenu class="dropdown-menu notification-toggle">-->
        <!--                &lt;!&ndash; START Notification &ndash;&gt;-->
        <!--                <div class="notification-panel">-->
        <!--                  &lt;!&ndash; START Notification Body&ndash;&gt;-->
        <!--                  <div class="notification-body scrollable">-->
        <!--                    &lt;!&ndash; START Notification Item&ndash;&gt;-->
        <!--                    <div class="notification-item unread clearfix">-->
        <!--                      &lt;!&ndash; START Notification Item&ndash;&gt;-->
        <!--                      <div class="heading open">-->
        <!--                        <a href="#" class="text-complete pull-left d-flex align-items-center">-->
        <!--                          <i class="pg-icon m-r-10">map</i>-->
        <!--                          <span class="bold">Carrot Design</span>-->
        <!--                          <span class="fs-12 m-l-10">David Nester</span>-->
        <!--                        </a>-->
        <!--                        <div class="pull-right">-->
        <!--                          <div class="thumbnail-wrapper d16 circular inline m-t-15 m-r-10 toggle-more-details">-->
        <!--                            <div><i class="pg-icon">chevron_down</i>-->
        <!--                            </div>-->
        <!--                          </div>-->
        <!--                          <span class=" time">few sec ago</span>-->
        <!--                        </div>-->
        <!--                        <div class="more-details">-->
        <!--                          <div class="more-details-inner">-->
        <!--                            <h5 class="semi-bold fs-16">“Apple’s Motivation - Innovation <br>-->
        <!--                              distinguishes between <br>-->
        <!--                              A leader and a follower.”</h5>-->
        <!--                            <p class="small hint-text">-->
        <!--                              Commented on john Smiths wall.-->
        <!--                              <br> via pages framework.-->
        <!--                            </p>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; END Notification Item&ndash;&gt;-->
        <!--                      &lt;!&ndash; START Notification Item Right Side&ndash;&gt;-->
        <!--                      <div class="option" tooltip="mark as read" placement="right">-->
        <!--                        <a href="javascript:void(0)" class="mark"></a>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; END Notification Item Right Side&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash; START Notification Body&ndash;&gt;-->
        <!--                    &lt;!&ndash; START Notification Item&ndash;&gt;-->
        <!--                    <div class="notification-item  clearfix">-->
        <!--                      <div class="heading">-->
        <!--                        <a href="javascript:void(0)" class="text-danger pull-left">-->
        <!--                          <i class="pg-icon m-r-10">alert_warning</i>-->
        <!--                          <span class="bold">98% Server Load</span>-->
        <!--                          <span class="fs-12 m-l-10">Take Action</span>-->
        <!--                        </a>-->
        <!--                        <span class="pull-right time">2 mins ago</span>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; START Notification Item Right Side&ndash;&gt;-->
        <!--                      <div class="option">-->
        <!--                        <a href="javascript:void(0)" class="mark"></a>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; END Notification Item Right Side&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash; END Notification Item&ndash;&gt;-->
        <!--                    &lt;!&ndash; START Notification Item&ndash;&gt;-->
        <!--                    <div class="notification-item  clearfix">-->
        <!--                      <div class="heading">-->
        <!--                        <a href="javascript:void(0)" class="text-warning pull-left">-->
        <!--                          <i class="pg-icon m-r-10">alert_warning</i>-->
        <!--                          <span class="bold">Warning Notification</span>-->
        <!--                          <span class="fs-12 m-l-10">Buy Now</span>-->
        <!--                        </a>-->
        <!--                        <span class="pull-right time">yesterday</span>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; START Notification Item Right Side&ndash;&gt;-->
        <!--                      <div class="option">-->
        <!--                        <a href="javascript:void(0)" class="mark"></a>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; END Notification Item Right Side&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash; END Notification Item&ndash;&gt;-->
        <!--                    &lt;!&ndash; START Notification Item&ndash;&gt;-->
        <!--                    <div class="notification-item unread clearfix">-->
        <!--                      <div class="heading">-->
        <!--                        <div class="thumbnail-wrapper d24 circular b-white m-r-5 b-a b-white m-t-10 m-r-10">-->
        <!--                          <img width="30" height="30" src2x="assets/img/profiles/1x.jpg" pgRetina-->
        <!--                            src1x="assets/img/profiles/1.jpg" alt="" src="assets/img/profiles/1.jpg">-->
        <!--                        </div>-->
        <!--                        <a href="javascript:void(0)" class="text-complete pull-left">-->
        <!--                          <span class="bold">Revox Design Labs</span>-->
        <!--                          <span class="fs-12 m-l-10">Owners</span>-->
        <!--                        </a>-->
        <!--                        <span class="pull-right time">11:00pm</span>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; START Notification Item Right Side&ndash;&gt;-->
        <!--                      <div class="option" tooltip="mark as read" placement="right">-->
        <!--                        <a href="javascript:void(0)" class="mark"></a>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash; END Notification Item Right Side&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash; END Notification Item&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash; END Notification Body&ndash;&gt;-->
        <!--                  &lt;!&ndash; START Notification Footer&ndash;&gt;-->
        <!--                  <div class="notification-footer text-center">-->
        <!--                    <a href="javascript:void(0)" class="">Read all notifications</a>-->
        <!--                    <a data-toggle="refresh" class="portlet-refresh text-black pull-right" href="javascript:void(0)">-->
        <!--                      <i class="pg-refresh_new"></i>-->
        <!--                    </a>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash; START Notification Footer&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash; END Notification &ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash; END Notification Dropdown &ndash;&gt;-->
        <!--            </div>-->
        <!--          </li>-->

        <!--          <ng-template [ngIf]="_layoutOption != 'email'">-->
        <!--            <li class="p-r-10 inline">-->
        <!--              <a href="javascript:void(0)" class="header-icon btn-icon-link">-->
        <!--                <i class="pg-icon">link_alt</i>-->
        <!--              </a>-->
        <!--            </li>-->
        <!--            <li class="p-r-10 inline">-->
        <!--              <a href="javascript:void(0)" class="header-icon btn-icon-link">-->
        <!--                <i class="pg-icon">grid_alt</i>-->
        <!--              </a>-->
        <!--            </li>-->
        <!--          </ng-template>-->

        <!--          <ng-template [ngIf]="_layoutOption == 'email'">-->
        <!--            <li class="inline">-->
        <!--              <a href="javascript:void(0)" id="mark-email" class="mark-email btn-icon-link m-l-10"><i-->
        <!--                  class="pg-icon">edit</i></a>-->
        <!--            </li>-->
        <!--          </ng-template>-->
        <!--        </ul>-->
        <!-- END NOTIFICATIONS LIST -->
        <!-- START User Info-->
        <div class="p-r-5 fs-14 font-heading d-lg-inline-block d-none">
          <span class="semi-bold">{{currUser.nameFirst}} </span> <span class="bold">{{currUser.nameLast}}</span>
        </div>
        <div class="dropdown pull-right d-lg-block" dropdown>
          <button class="profile-dropdown-toggle" type="button" dropdownToggle id="profileDropdown"
            aria-label="profile dropdown">
            <span class="thumbnail-wrapper d32 circular inline">
              <i class="pg-icon" [class.text-danger]="isSavingDeal">{{ isSavingDeal ? 'save' : 'user' }}</i>
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu-right profile-dropdown" *dropdownMenu role="menu">
            <a href="#" class="dropdown-item"><span>Signed in as <br /><b>{{currUser.nameFirst}}
                  {{currUser.nameLast}}</b></span></a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">{{currUser.email}}</a>
            <!--            <a href="#" class="dropdown-item">Your Activity</a>-->
            <!--            <a href="#" class="dropdown-item">Your Archive</a>-->
            <!--            <div class="dropdown-divider"></div>-->
            <!--            <a href="#" class="dropdown-item">Features</a>-->
            <!--            <a href="#" class="dropdown-item">Help</a>-->
            <!--            <a href="#" class="dropdown-item">Settings</a>-->
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item" (click)="logout()">Logout</a>
            <!--            <span class="dropdown-item fs-12 hint-text">Last edited by David<br />on Friday at 5:27PM</span>-->
          </div>
        </div>
        <!-- END User Info-->
        <!--        <a href="javascript:void(0)" class="header-icon btn-icon-link m-l-5 sm-no-margin d-inline-block btn-icon-link"-->
        <!--          (click)="openQuickView($event)">-->
        <!--          <i class="pg-icon">menu_add</i>-->
        <!--        </a>-->
      </div>
    </pg-header>
    <div class="page-content-wrapper {{_pageContainerClass}}">
      <!-- START PAGE CONTENT -->
      <div class="content {{_contentClass}}">
        <router-outlet></router-outlet>
      </div>
      <!-- END PAGE CONTENT -->
      <!-- START COPYRIGHT -->
      <ng-template [ngIf]="_footer">
        <div class=" container-fluid container-fixed-lg footer">
          <div class="copyright sm-text-center">
            <p class="small no-margin pull-left sm-pull-reset">
              <span class="hint-text">Copyright &copy; 2025</span>&nbsp;<span class="font-montserrat">
                American Window Film
              </span>.
            </p>
            <div class="clearfix">
            </div>
          </div>
        </div>
        <!-- END COPYRIGHT -->
      </ng-template>
    </div>
  </page-container>
  <!-- QUICKSEARCH -->
  <!-- <app-search-overlay></app-search-overlay> -->
  <!-- QUICKVIEW -->
  <!-- <app-quickview></app-quickview> -->
</ng-template>